import script from "./TwoFactorAuth.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoFactorAuth.vue?vue&type=script&setup=true&lang=js"

import "./TwoFactorAuth.vue?vue&type=style&index=0&id=1e8fbdd8&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ringg_deliveryhub-app_production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e8fbdd8"]])

export default __exports__